import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";

const http = new AxiosAdapter();

export const getAllContratosService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`/v1/human-talent/contracts?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAllContratosService ', error);
    }
}

export const createContratoService = async (data: any) => {
    try {
        return await http.post<any>(`/v1/human-talent/contracts`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('createContratoService ', error);
    }
}

export const updateContratoService = async (id: string, data: any) => {
    try {
        return await http.put<any>(`/v1/human-talent/contracts/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('updateContratoService ', error);
    }
}

export const getContratoDetailService = async (id: string) => {
    try {
        return await http.get<any>(`/v1/human-talent/contracts/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getContratoDetailService ', error);
    }
}

export const deleteContratoService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.delete<any>(`/v1/human-talent/contracts/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('deleteContratoService ', error);
    }
}

export const restoreContratoService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`/v1/human-talent/contracts/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('restoreContratoService ', error);
    }
}
